export default  {
  bindings: {
    treatment: '=',
    title: '@'
  },
  controller: 'treatmentSaveController',
  template: require('../views/treatment.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/components/treatment.save.component.js